// AUTO-GENERATED by scripts/generate-glossary-data.js - do not edit by hand.
// Flat list of slugs with a real glossary page, used to filter relatedTerms
// links on prompt/guide/feature pages so none of them can point at a 404.
export const GLOSSARY_SLUGS = new Set([
  "3-2-1-backup-rule",
  "a-better-finder-rename-alternative",
  "academic-file-management",
  "adaptive-organization",
  "adhd-file-organization",
  "advanced-renamer-alternative",
  "advanced-renamer-vs-bulk-rename-utility",
  "affordable-ai-file-organization-tool",
  "ai-file-organization-software-for-pc",
  "ai-file-organizer",
  "ai-file-renamer",
  "ai-file-search",
  "ai-powered-file-manager",
  "ai-powered-search",
  "ai-tool-to-organize-messy-desktop",
  "alias-files",
  "application-support-files",
  "archive-file-management",
  "audio-file-organization",
  "automate-file-organization",
  "automated-backup-organization",
  "automated-classification",
  "automated-document-classification",
  "automated-file-naming-conventions-software",
  "automated-file-sorting",
  "automated-filing-system",
  "automatic-desktop-organization-tools",
  "automatic-file-categorization-tools",
  "automatic-file-organization-software-mac",
  "automatic-file-organizer-software-price",
  "automatic-file-renaming",
  "automatic-folder-sorting",
  "automatically-delete-old-files",
  "automatically-move-files-between-folders",
  "automator-file-workflows",
  "back-to-school-laptop-organization",
  "batch-file-operations",
  "batch-file-renaming",
  "batch-file-renaming-tools",
  "bates-numbering-file-organization",
  "best-bulk-rename-software-windows",
  "best-document-management-software-mac",
  "best-document-organizer-small-business",
  "best-file-manager-windows-11",
  "best-file-organization-app-for-mac-desktop",
  "best-file-organization-software-2025",
  "best-file-organizer-accountants",
  "best-file-organizer-architects",
  "best-file-organizer-consultants",
  "best-file-organizer-freelancers",
  "best-file-organizer-lawyers",
  "best-file-organizer-music-producers",
  "best-file-organizer-photographers",
  "best-file-organizer-podcasters",
  "best-file-organizer-real-estate",
  "best-file-organizer-researchers",
  "best-file-organizer-teachers",
  "best-file-organizer-windows-11",
  "best-file-organizer-youtubers",
  "best-folder-structure-business",
  "best-folder-structure-personal",
  "best-free-file-organizer-windows",
  "best-way-organize-computer-files",
  "better-than-manual-filing",
  "binary-file-comparison",
  "bookmark-organization",
  "building-a-second-brain",
  "bulk-file-metadata-editing",
  "bulk-file-operations",
  "bulk-pdf-organization",
  "bulk-photo-organization-tools",
  "bulk-rename-utility-alternative",
  "bulk-video-file-renaming",
  "business-file-management-system-roi",
  "business-process-management",
  "cache-cleanup",
  "cad-file-management",
  "can-ai-organize-my-files",
  "can-ai-organize-my-files-for-me",
  "cant-find-files-mac",
  "cant-find-files-quickly",
  "case-file-management",
  "chaotic-file-storage",
  "checksum-file-verification",
  "citation-management-software",
  "clean-up-mac-hard-drive",
  "client-folder-structure",
  "cloud-file-organization",
  "cloud-file-sync",
  "cognitive-computing",
  "collaborative-file-management",
  "commander-one-alternative",
  "compliance-management",
  "computer-file-organization",
  "construction-project-folder-structure",
  "content-analysis",
  "content-based-file-organization",
  "contract-lifecycle-management",
  "create-folders-from-file-names",
  "creative-asset-management",
  "creative-file-management",
  "cross-platform-file-syncing",
  "czkawka-alternative",
  "czkawka-vs-dupeguru",
  "data-room-organization",
  "date-based-organization",
  "declutter-mac-desktop",
  "delete-empty-folders",
  "design-file-organization",
  "desktop-file-organization",
  "desktop-icon-management",
  "desktop-organization",
  "developer-file-organization",
  "devonthink-vs-hazel",
  "devonthink-vs-paperless-ngx",
  "digital-asset-management",
  "digital-asset-management-platform-reviews",
  "digital-clutter-management",
  "digital-decluttering",
  "digital-file-organization-system",
  "digital-filing-system",
  "digital-hoarding",
  "digital-spring-cleaning",
  "digital-video-filing-system",
  "directory-structure-organization",
  "disk-space-cleanup",
  "disorganized-documents-cleanup",
  "document-management",
  "document-management-system",
  "document-retrieval-problems",
  "document-version-control-issues",
  "dotfiles-management",
  "double-commander-vs-total-commander",
  "downloads-folder-organization",
  "dropbox-organization",
  "dropzone-vs-yoink",
  "dupeguru-alternative",
  "duplicate-file-finder",
  "duplicate-files-removal",
  "eagle-app-alternative",
  "ebook-organization",
  "ediscovery-document-production-organization",
  "efficient-file-management",
  "effortless-file-sorting",
  "eliminate-manual-sorting",
  "email-attachment-organization",
  "employee-personnel-file-organization",
  "enterprise-content-management",
  "enterprise-file-organization-solution-comparison",
  "everything-search-for-mac",
  "export-apple-photos-to-folders-by-date",
  "external-drive-organization",
  "family-photo-organization",
  "file-attributes-management",
  "file-audit",
  "file-backup-strategies",
  "file-categorization",
  "file-chaos-solutions",
  "file-clutter-anxiety",
  "file-comparison",
  "file-compression",
  "file-deduplication",
  "file-encryption",
  "file-hierarchy",
  "file-indexing-systems",
  "file-inspector",
  "file-juggler-vs-dropzone",
  "file-location-tracking",
  "file-management-software",
  "file-management-software-for-business-pricing",
  "file-migration",
  "file-naming-conventions",
  "file-naming-conventions-guide",
  "file-naming-inconsistencies",
  "file-organization-app-subscription-plans",
  "file-organization-best-practices",
  "file-organization-habits",
  "file-organization-software",
  "file-organizer-app-windows",
  "file-overload-solutions",
  "file-permissions",
  "file-preview",
  "file-recovery",
  "file-retention-policy",
  "file-search-difficulties",
  "file-sharing",
  "file-sorting-software-free-trial",
  "file-sync",
  "file-system-analytics",
  "file-system-organization",
  "file-tagging",
  "file-taxonomy",
  "file-type-organization",
  "file-version-confusion",
  "file-versioning",
  "filebot-vs-sonarr",
  "filebot-vs-tinymediamanager",
  "filename-pattern-matching",
  "filename-too-long-windows",
  "financial-document-organization",
  "find-duplicate-files-mac",
  "find-files-instantly",
  "finder-tips-tricks",
  "fix-file-organization-problems",
  "flat-file-organization",
  "flatten-folder-structure",
  "folder-color-coding",
  "folder-depth-best-practice",
  "folder-naming-conventions",
  "folder-structure",
  "folder-structure-best-practices",
  "folder-structure-template",
  "font-organization",
  "free-file-organizer-mac",
  "game-asset-naming-convention",
  "genealogy-file-organization",
  "going-freelance-file-setup",
  "google-drive-organization",
  "google-takeout-photo-organization",
  "gtd-file-organization",
  "hard-drive-full-what-to-delete",
  "hazel-rules-examples",
  "hazel-vs-dropit",
  "hidden-files-mac",
  "hierarchical-folder-structure",
  "how-do-i-organize-files-without-folders",
  "how-do-i-organize-thousands-of-files",
  "how-to-backup-organized-file-system",
  "how-to-consolidate-files-from-multiple-sources",
  "how-to-find-files-quickly-on-computer",
  "how-to-migrate-from-manual-to-automated-filing",
  "how-to-organize-a-shared-team-drive",
  "how-to-organize-digital-files-like-a-pro",
  "how-to-organize-files-across-multiple-devices",
  "how-to-organize-files-by-project-efficiently",
  "how-to-organize-files-for-compliance",
  "how-to-organize-files-for-easy-searching",
  "how-to-organize-files-for-remote-work",
  "how-to-organize-files-on-mac-automatically",
  "how-to-organize-files-when-working-from-home",
  "how-to-organize-messy-desktop-files",
  "how-to-organize-shared-project-files",
  "how-to-organize-thousands-of-files-on-mac",
  "how-to-organize-work-files-on-a-new-laptop",
  "how-to-share-organized-files-with-team",
  "how-to-sort-files-in-folders-windows-10",
  "how-to-start-organizing-old-files",
  "icon-organization",
  "image-metadata-management",
  "image-sorting-by-date-and-location",
  "immigration-document-organization",
  "inbox-zero-files",
  "instant-file-search",
  "intelligent-document-management",
  "intelligent-file-management",
  "intelligent-file-manager-software-download",
  "intelligent-file-search",
  "invoice-numbering-system",
  "iso-8601-date-file-naming",
  "johnny-decimal-system",
  "keyboard-shortcuts-files",
  "knowledge-management-system",
  "large-file-management",
  "law-firm-filing-system",
  "legal-document-organization",
  "lightroom-file-organization",
  "log-file-management",
  "lost-important-documents",
  "machine-learning-algorithms",
  "machine-learning-classification",
  "machine-learning-file-sorting",
  "machine-learning-file-sorting-software",
  "macos-tags",
  "media-library-management-system",
  "medical-record-organization",
  "merge-folders-on-mac",
  "messy-desktop-cleanup",
  "metadata-extraction",
  "metadata-file-organization",
  "metadata-management",
  "missing-file-recovery",
  "mortgage-application-document-organization",
  "movie-file-naming-convention",
  "music-library-organization",
  "name-mangler-vs-renamer",
  "namequick-vs-a-better-finder-rename",
  "nas-file-organization",
  "natural-language-file-search",
  "natural-language-processing",
  "network-drive-organization",
  "new-computer-file-organization",
  "new-computer-file-setup",
  "new-year-digital-cleanup",
  "note-organization",
  "notion-database-organization",
  "obs-recording-file-organization",
  "obsidian-vault-organization",
  "ocr-text-recognition",
  "one-click-organization",
  "onedrive-duplicate-files-computer-name",
  "onedrive-invalid-filename-characters",
  "onedrive-organization",
  "organize-by-date-vs-type-vs-project",
  "organize-computer-files-by-type-automatically",
  "organize-computer-files-efficiently",
  "organize-desktop-in-seconds",
  "organize-downloads-folder-automatically-windows",
  "organize-email-attachments",
  "organize-external-hard-drive",
  "organize-files-automatically-windows",
  "organize-files-before-migration",
  "organize-files-by-content-not-name",
  "organize-files-by-date",
  "organize-files-by-date-automatically-windows",
  "organize-files-by-project",
  "organize-files-quickly",
  "organize-google-drive",
  "organize-icloud-drive",
  "organize-images-by-keywords",
  "organize-inherited-computer-files",
  "organize-invoices-and-receipts-automatically",
  "organize-invoices-small-business",
  "organize-music-files",
  "organize-pdf-files-automatically",
  "organize-pdfs-by-content-automatically",
  "organize-photos-by-date-automatically",
  "organize-photos-by-face-recognition",
  "organize-receipts-digitally",
  "organize-scanned-documents",
  "organize-screenshots-mac",
  "organize-screenshots-windows",
  "organize-shared-drive-work",
  "organize-stl-files-3d-printing",
  "organize-videos-by-date-and-size",
  "organize-videos-by-keywords",
  "paperless-ngx-vs-hazel",
  "paperless-office",
  "paperless-office-setup",
  "para-method",
  "para-method-file-organization",
  "path-finder-alternative-mac",
  "path-management-solutions",
  "patient-file-management",
  "pattern-recognition",
  "pdf-categorization-tools",
  "pdf-metadata-organization",
  "pdf-organization",
  "pdf-organization-software",
  "photo-culling-workflow",
  "photo-library-organization",
  "photo-library-sorting",
  "photo-mechanic-alternative",
  "photo-organization-software-comparison",
  "picasa-alternative",
  "picture-file-management-system",
  "plex-media-library-organization",
  "podcast-episode-file-structure",
  "podcast-file-management",
  "power-automate-desktop-move-files",
  "powerrename-alternative",
  "powershell-script-to-organize-files",
  "predictive-filing",
  "premiere-pro-project-organization",
  "presentation-organization",
  "productivity-file-management",
  "professional-document-organizer-tool-cost",
  "project-file-organization",
  "property-management-document-organization",
  "python-script-to-organize-files",
  "rapid-document-retrieval",
  "raw-file-organization",
  "real-estate-transaction-folder-organization",
  "recipe-organization",
  "records-management",
  "recursive-file-sorting",
  "redundant-file-management",
  "remove-spaces-from-filenames",
  "rename-files-from-spreadsheet",
  "rename-pdf-files-based-on-content",
  "rename-photos-by-date-taken",
  "replace-manual-file-organization",
  "research-data-folder-structure",
  "research-file-organization",
  "research-paper-organization",
  "scansnap-home-alternative",
  "screenshot-organization",
  "scrivener-project-file-organization",
  "seamless-file-organization",
  "search-functionality-issues",
  "searchable-pdf-management",
  "secure-file-archiving",
  "secure-file-deletion",
  "semantic-search",
  "separate-business-personal-files",
  "separate-raw-and-jpeg-files",
  "shared-drive-permission-sprawl",
  "shared-mailbox-attachment-management",
  "sharepoint-file-organization",
  "should-i-organize-files-by-date-or-type",
  "smart-document-filing",
  "smart-file-organization",
  "smart-file-organization-system",
  "smart-file-sorting",
  "smart-folder-automation",
  "smart-folder-creation",
  "smart-folders-mac",
  "software-to-automatically-sort-files-by-date",
  "solve-digital-clutter",
  "split-folder-into-subfolders",
  "spotlight-not-finding-files",
  "spotlight-search-tips",
  "spreadsheet-organization",
  "stacks-mac",
  "stop-manual-file-management",
  "stop-naming-files-final-v2",
  "storage-analysis",
  "storage-space-optimization",
  "streamline-file-workflow",
  "student-course-file-organization",
  "student-document-sorting",
  "supervised-learning",
  "symbolic-links",
  "tag-based-organization",
  "tagstudio-vs-tagspaces",
  "tax-season-document-collection",
  "tax-season-file-organization",
  "tax-workpaper-organization",
  "temporary-files",
  "thesis-document-management",
  "too-many-files-on-desktop",
  "trash-management",
  "travel-document-organization",
  "turn-off-group-by-date-windows-downloads",
  "tv-show-file-naming-convention",
  "unorganized-computer-files",
  "unsupervised-learning",
  "version-control",
  "version-control-for-documents",
  "video-file-organization-software",
  "video-metadata-management",
  "video-project-folder-structure",
  "voice-memo-organization",
  "watch-folder-automation",
  "what-is-a-file-extension",
  "what-is-the-best-way-to-sort-computer-files",
  "what-to-do-with-duplicate-files",
  "whats-the-best-file-naming-convention",
  "why-cant-i-find-my-downloaded-files",
  "windows-file-management-tips-for-beginners",
  "windows-search-not-finding-files",
  "workflow-automation",
  "workflow-optimization",
  "workspace-optimization",
  "xyplorer-alternative",
  "year-end-digital-cleanup",
  "zettelkasten-method",
  "zotero-rename-pdf-attachments"
]);

export const isGlossarySlug = (slug) => GLOSSARY_SLUGS.has(slug);
